/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PermissionModel } from '../../models/permission-model';

export interface GetApiRoleV1Permissions$Json$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
}

export function getApiRoleV1Permissions$Json(http: HttpClient, rootUrl: string, params?: GetApiRoleV1Permissions$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PermissionModel>>> {
  const rb = new RequestBuilder(rootUrl, getApiRoleV1Permissions$Json.PATH, 'get');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PermissionModel>>;
    })
  );
}

getApiRoleV1Permissions$Json.PATH = '/private/v1/permissions';
